import type { SubjectLineCondition as SubjectLineConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";

export const SubjectLineCondition = memo(function SubjectLineCondition({
  condition,
  onChange,
}: {
  condition: SubjectLineConditionType;
  onChange: (updated: SubjectLineConditionType) => void;
}) {
  const [inputValue, setInputValue] = useState("");

  return (
    <Flex dir="column" gap="lg" w="full">
      <RedoTagInputField
        delimiters={["newline"]}
        inputValue={inputValue}
        label="Subject text to match"
        placeholder="Enter subject text to match"
        setInputValue={setInputValue}
        setTags={(queryStrings) => {
          const uniqueStrings = Array.from(new Set(queryStrings));
          onChange({ ...condition, queryStrings: uniqueStrings });
        }}
        state="default"
        tags={(condition.queryStrings || []).map((text) => ({ text }))}
      />
      <RedoCheckbox
        label="Case sensitive"
        setValue={(v) => onChange({ ...condition, caseSensitive: v === true })}
        size="sm"
        value={condition.caseSensitive || false}
      />
    </Flex>
  );
});
